import { useEffect, useRef, useState } from 'react';
import { cn } from '../../lib/utils';

export function BackgroundBeams({ className }) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (!containerRef.current) return;
      const rect = containerRef.current.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      setMousePosition({ x, y });
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      if (container) {
        container.removeEventListener('mousemove', handleMouseMove);
      }
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={cn(
        'absolute inset-0 overflow-hidden pointer-events-none',
        className
      )}
    >
      {/* Grid pattern */}
      <div className="absolute inset-0 bg-dot-pattern opacity-30" />

      {/* Gradient glow following mouse */}
      <div
        className="absolute w-[500px] h-[500px] rounded-full opacity-20 blur-3xl transition-all duration-300 ease-out"
        style={{
          background: 'radial-gradient(circle, rgba(59, 130, 246, 0.3) 0%, transparent 70%)',
          left: mousePosition.x - 250,
          top: mousePosition.y - 250,
        }}
      />

      {/* Static gradient orbs */}
      <div className="absolute top-0 left-1/4 w-[300px] h-[300px] rounded-full bg-blue-500/5 blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] rounded-full bg-purple-500/5 blur-3xl" />
    </div>
  );
}

export function BackgroundGradient({ children, className, containerClassName }) {
  return (
    <div className={cn('relative group', containerClassName)}>
      {/* Animated gradient border */}
      <div
        className={cn(
          'absolute -inset-0.5 rounded-xl bg-gradient-to-r from-primary to-purple-500 opacity-0 blur transition duration-500 group-hover:opacity-30',
        )}
      />
      <div className={cn('relative rounded-xl bg-card', className)}>
        {children}
      </div>
    </div>
  );
}

export function GlowingStars({ className }) {
  const stars = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 2}s`,
    size: Math.random() * 2 + 1,
  }));

  return (
    <div className={cn('absolute inset-0 overflow-hidden pointer-events-none', className)}>
      {stars.map((star) => (
        <div
          key={star.id}
          className="absolute rounded-full bg-blue-400 animate-pulse-slow"
          style={{
            top: star.top,
            left: star.left,
            width: star.size,
            height: star.size,
            animationDelay: star.animationDelay,
            opacity: 0.3,
          }}
        />
      ))}
    </div>
  );
}
